import { render, staticRenderFns } from "./orderStatusInfo.vue?vue&type=template&id=05685df0&"
import script from "./orderStatusInfo.vue?vue&type=script&lang=js&"
export * from "./orderStatusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports